import { Navigate, useLocation, useParams } from "react-router-dom";
import { SettingsTabId } from "@/store/pages/SettingsPageStore";
import { appRoutes, SETTINGS_TEMPLATE_ID_SEARCH_PARAM } from "@/app/router/appRoutes";

export const SettingsRedirect = ({
  tabId,
  templateId,
}: {
  tabId: SettingsTabId;
  templateId?: string;
}) => {
  const searchParams = new URLSearchParams({ settings: tabId });
  if (templateId) searchParams.set(SETTINGS_TEMPLATE_ID_SEARCH_PARAM, templateId);

  return <Navigate to={`${appRoutes.notesList({}).path}?${searchParams.toString()}`} replace />;
};

export const TemplateSettingsRedirect = () => {
  const { templateId } = useParams<{ templateId: string }>();

  return <SettingsRedirect tabId={SettingsTabId.TemplatesPage} templateId={templateId} />;
};

export const LegacySettingsRemindersRedirect = () => {
  const location = useLocation();

  return (
    <Navigate
      to={`${appRoutes.settingsMemAgent({}).path}${location.search}${location.hash}`}
      replace
    />
  );
};
